import RequestHandler from "./RequestHandler";

function OrganizationSubscriptionsAPI() {
    const baseOrganizationSubscriptionsAPI = "organization-subscriptions";

    async function getSubscriptions(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            const URL = `${baseOrganizationSubscriptionsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getMySubscriptions(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            const URL = `${baseOrganizationSubscriptionsAPI}/subscriptions?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function subscribe(subscriptionId) {
        try {
            const result = await RequestHandler.post(
                `${baseOrganizationSubscriptionsAPI}/subscribe`,
                subscriptionId
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function confirmSubscription(subscriptionId) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationSubscriptionsAPI}/confirm/${subscriptionId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function validateSubscription(sessionId, promotionCode = "") {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationSubscriptionsAPI}/validate-subscription/${sessionId}${
                    promotionCode ? `?promotion-code=${promotionCode}` : ""
                }`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createCheckoutSession(
        subscriptionPlanId,
        promotionCode = ""
    ) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationSubscriptionsAPI}/create-checkout-session/${subscriptionPlanId}${
                    promotionCode ? `?promotion-code=${promotionCode}` : ""
                }`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deploySubscription(payload) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationSubscriptionsAPI}/deploy`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function upgradeVersion(payload) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationSubscriptionsAPI}/upgrade`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function unsubscribeModel(payload) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationSubscriptionsAPI}/unsubscribe/${payload}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateBiasCorrections(payload) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationSubscriptionsAPI}/bias-corrections`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateSubscriptionAccess(payload) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationSubscriptionsAPI}/subscription-access`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function selectDisplayUnit(payload) {
        try {
            const result = await RequestHandler.post(
                `${baseOrganizationSubscriptionsAPI}/select-display-unit`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getSelectedDisplayUnit(
        modelParameterProductVersionId,
        organizationSubscriptionId,
        subscriptionMaterialId
    ) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationSubscriptionsAPI}/selected-display-unit?modelParameterProductVersionId=${modelParameterProductVersionId}&organizationSubscriptionId=${organizationSubscriptionId}&subscriptionMaterialId=${subscriptionMaterialId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getSubscriptions,
        subscribe,
        getMySubscriptions,
        deploySubscription,
        selectDisplayUnit,
        getSelectedDisplayUnit,
        confirmSubscription,
        createCheckoutSession,
        validateSubscription,
        upgradeVersion,
        unsubscribeModel,
        updateBiasCorrections,
        updateSubscriptionAccess,
    };
}

export default OrganizationSubscriptionsAPI();
